export default __webpack_public_path__ + "images/934b1083aba722a9b816868f196a7521.svg";